import { wrapCall, callGet, callPost, callDelete } from './helpers'

//* ~~~~~~ VIEWS ROUTES ~~~~~~

// Get views
export const getViews = async () => {
  return (await wrapCall({ method: callGet, uri: '/views' })) as APIView[]
}

// Create view
export const createView = async (data: ViewUpdate) => {
  return (await wrapCall({ method: callPost, uri: '/views', data })) as APIView
}

// Delete view
export const deleteView = async (id: string) => {
  return await wrapCall({ method: callDelete, uri: `/views/${id}` })
}
